export default "__VITE_ASSET__D8Yghql7__"